import { useMutation } from '@tanstack/react-query';

import { CancelSubscriptionResponse } from '@/api/subscriptions/types';
import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';
import { STRIPE_CURRENT_CUSTOMER_INFO_QUERY_KEY, SUBSCRIPTION_TAGS_INFO_QUERY_KEY } from '@/config';

export const cancelSubscription = (subscriptionId: string): Promise<CancelSubscriptionResponse> => {
    return axios.post(`/api/v2/subscriptions/${subscriptionId}/cancel`);
};

type UseCancelSubscriptionsOptions = {
    config?: MutationConfig<typeof cancelSubscription>;
    data?: {
        subscriptionId: string;
    };
};

export const useCancelSubscription = ({ config }: UseCancelSubscriptionsOptions = {}) => {
    return useMutation({
        ...config,
        mutationFn: cancelSubscription,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['stripe-subscription-info'] });
            queryClient.invalidateQueries({
                queryKey: ['stripe-updated-quantity-upcoming-invoice'],
            });
            // customer info has current user's credit balance which changes upon subscription creation/cancelation
            queryClient.invalidateQueries({ queryKey: [STRIPE_CURRENT_CUSTOMER_INFO_QUERY_KEY] });
            queryClient.invalidateQueries({ queryKey: [SUBSCRIPTION_TAGS_INFO_QUERY_KEY] });
        },
    });
};
